mutation StopEvent($eventId: ID!) {
  event: StreamToolsStopEvent(eventId: $eventId) {
    eventId
    status
  }
}
